import React from "react";
import Modal from "../../../components/ui/Modal";
import { Button } from "../../../components/ui/Buttons";
import CloseIcon from "../../../components/Icon/Close";
import { SelectForm } from "../../../components/Modal/Input";
import { withStyles } from "@material-ui/core";

const ModalSelectOptions = ({
    classes,
    isOpen,
    title,
    onClose,
    options,
    textButton,
    handleClickButton,
    handleChangeSelect,
    valueSelect,
}) => {

    return (
        <Modal isOpen={isOpen}>
            <div className={classes.container}>
                <div className={classes.header}>
                    <span className={classes.title}>{title}</span>
                    <Button
                        id="agd-mso-btn-cls"
                        bgColor={"#FB6D6D"}
                        color={'#fff'}
                        kind="transparent"
                        shape="circle"
                        onClick={onClose}
                        size={'mini'}
                    >
                        <CloseIcon />
                    </Button>
                </div>
                <div className={classes.content}>
                    <SelectForm
                        id="agd-mso-sel-opc"
                        elements={options}
                        value={valueSelect}
                        onChange={handleChangeSelect}
                    />
                </div>
                <div className={classes.contenButton}>
                    <Button
                        id="agd-mso-btn-ava"
                        onClick={handleClickButton}
                        className={classes.button}
                    >
                        {textButton}
                    </Button>
                </div>
            </div>
        </Modal >
    )
}

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        height: 'fit-content',
        width: '300px',
        backgroundColor: '#fff',
        borderRadius: '16px',
        padding: '20px',
        gap: '17px'
    },
    header: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        height: '48px',
    },
    title: {
        fontSize: '15px',
        fontWeight: '700',
        color: '#505050'
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        gap: '16px',
    },
    button: {
        width: "100px",
    },
    contenButton: {
        width: '100%',
        display: 'flex',
        justifyContent: 'flex-end'
    }
}
export default withStyles(styles)(ModalSelectOptions);